import { Component, Inject } from '@angular/core';
import { GetPayinTokensService } from 'src/app/shared/services/api/get-payin-tokens.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/shared/services/user.service';
import { DWDPATSessionModel } from 'src/app/shared/models/session.model';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { GetGuidService } from 'src/app/shared/services/api/get-guid.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { CreditCard, GetPaymentMethodsRequest, GetPaymentMethodsResponse, ListCreditCardsRequest, ListCreditCardsResponse } from 'src/app/shared/models/authorizeNet.model';
import { AuthorizePaymentService } from 'src/app/shared/services/api/authorize-payment.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-method-flyout',
  templateUrl: './payment-method-flyout.component.html',
  styleUrls: ['./payment-method-flyout.component.scss']
})
export class PaymentMethodFlyoutComponent {
  
  // Flyout
  selectedToken; // Selected payment method within the flyout component
  achMethods;
  ccMethods;
  allMethods;
  paymenttokens: any;
  cctokens: any;
  ectokens: any;
  flyoutLoading: boolean = false;
  flyoutSystemError: boolean = false;
  flyoutExpiredMessage: boolean = false;
  flyoutWarningMessage: boolean = false;
  paymentTokensAvailable:boolean=false;
  walletDetails: any;
  selectedInvoice: any;
  paymentSummaryValues: any;
  currentDefaultPaymentMethod: any;
  useAutofill: any;
  sessionobj:any='';
  isPPI:boolean=false;

  constructor(private router: Router,
    public getpayintoken: GetPayinTokensService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<PaymentMethodFlyoutComponent>,
    private userService: UserService,
    public sessionService: GetGuidService,public sessionServiceAPI: SessionService,private authorizePaymentService: AuthorizePaymentService
  ) {
    this.walletDetails = this.userService.getWalletDetails();
    this.selectedInvoice = data?.selectedInvoice;
    this.paymentSummaryValues = data?.paymentSummaryValues;
    this.currentDefaultPaymentMethod = data?.currentDefaultPaymentMethod;
    this.selectedToken = data?.currentDefaultPaymentMethod?.token;
    this.useAutofill = data?.useAutofill;
    this.isPPI = this.sessionServiceAPI.isPPI()?? false;
  }

  ngOnInit() {
    this.getPaymentTokens();
    
  }

  getPaymentTokens() {
    this.flyoutLoading = true;
    this.flyoutSystemError = false;
    
    
          if (this.isPPI) {
            const walletId = JSON.parse(sessionStorage.getItem("WalletID") || 'null'); 
          const sessionId = sessionStorage.getItem("SessionID") || '';
          const userID = sessionStorage.getItem("PPIUserID") || '';
          const customerID = sessionStorage.getItem("PPICustomerID") || '';
          
          console.log("DEBUG - walletId:", walletId, "userID:", userID, "customerID:", customerID, "sessionID:", sessionId);
          
          const request: GetPaymentMethodsRequest = {
            walletID: walletId,
            userID,
            customerID,
            sessionID: sessionId
          };
          
          
            this.authorizePaymentService.getPaymentMethods(request).subscribe({
              next: (response: GetPaymentMethodsResponse) => {
                if (response.ppi?.success && response.ppi.paymentMethods?.length > 0) {
                  this.paymentTokensAvailable = true;
                  this.cctokens = response.ppi.paymentMethods;

                this.allMethods = []; this.flyoutLoading=false;  
                this.allMethods = response.ppi.paymentMethods; // No ACH for PPI in this view
    
                let defaultFound = false;
                this.cctokens.forEach((card: CreditCard) => {
                  if(card.last4.length>4)
                    {
                      card.last4=card.last4.substring(card.last4.length-4,card.last4.length);
                    }
                    card.token=card.userCreditCardId;
                  if (card.isDefault === true) {
                    
                    this.selectedToken = card.userCreditCardId;
                    defaultFound = true;
                  }
                });
    
          
                  // Add cardImg (optional: reuse your getcardImage utility)
                  this.cctokens.forEach((card: CreditCard) => {
                    card.cardImg = this.getpayintoken.getcardImage(card.creditCardType, '');
                    card.isDefault = String(card.isDefault).toLowerCase() === 'true';  
                  });
          
                } else {
                  this.flyoutLoading=false;       
                }
              },
              error: (error) => {
                console.error('Error fetching PPI payment tokens (dwGetPaymentMethod):', error);
               
              }
            });
    
          
        } else{
    let walletID = JSON.parse(sessionStorage.getItem('WalletID')!);
    this.getpayintoken.fetchpayintokens(walletID).subscribe(
      data => {
        this.flyoutLoading = false;

        this.allMethods = data?.paymentMethods;
        this.ccMethods = this.allMethods?.filter((x: any) => x.paymentMethod == 'CC');
        this.achMethods = this.allMethods?.filter((x: any) => (x.paymentMethod == 'ECP' || x.paymentMethod == 'EC'));

        // go through all cc methods to check to see if any are expiring or close to expiring
        for (let i = 0; i < this.ccMethods?.length; i++) {
          this.ccMethods[i].isExpired = this.checkCCExpiration(this.ccMethods[i].ccexpiration, 'expired');
          this.ccMethods[i].isWarning = this.checkCCExpiration(this.ccMethods[i].ccexpiration, 'warning');
        }
      }, error => {
        this.flyoutLoading = false;
        this.flyoutSystemError = true;
      }
    );
  }
  }

  closeFlyout() {
    this.dialog.close();
  }

  addNewPaymentMethod() {
    if(this.isPPI)
    {
      this.dialog.close();
        // For PPI, navigate directly to hosted-payment page
        this.router.navigate(['/hosted-payment']);
        console.log('PaymentMethodFlyout: Navigating to hosted-payment for PPI user.');
    }else
    {
    // Save their progress in sessionStorage, and then take them to DPAT
    let saveInvoicePaymentProgress = {
      selectedInvoice: this.selectedInvoice,
      paymentSummaryValues: this.paymentSummaryValues,
      currentDefaultPaymentMethod: this.currentDefaultPaymentMethod,
      useAutofill: this.useAutofill
    };
    if(sessionStorage.length>0)
    {
    this.sessionobj=JSON.parse(sessionStorage.getItem('ONLWalletSession') || '{}');
    }    
      
    sessionStorage.setItem('currentInvoiceProgress', JSON.stringify(saveInvoicePaymentProgress));
    let sessionID=sessionStorage.getItem("SessionID");
    let isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
    let request = new DWDPATSessionModel();
    request = {
      action: 'addpayinpayment',
      callBackURL: `${ApiEndpoints.startWalletSessionCallBack}/my-wallet/all-rewards/redeem/outstanding-invoice`,
      country: 'US',
      createdByUserId: 'appdw',
      locale: 'en',
      navigatingSystem: 'dw',
      paymentDirection: 'payin',
      walletID: this.walletDetails?.walletID,
      cashBalance:this.walletDetails?.cash?.totalCashBalance.toString(),
      rewardsBalance:this.walletDetails?.rewards?.totalRewardBalance.toString(),
      sessionID:sessionID,
      billingSystem:this.sessionobj.billingSystem,
      payorID:this.sessionobj.payorID,
      userEmail:this.sessionobj.userEmail,
      rewardsEligible:!isBilliant
    }

    this.sessionService.createdwdpatwalletsession(request);
  }
  }

  displayExpirationMessage(option) {
    this.flyoutExpiredMessage = option.isExpired;
    this.flyoutWarningMessage = option.isWarning;
  }

  updatePaymentMethod() {
    this.flyoutSystemError = false;
    this.flyoutExpiredMessage = false;
    this.flyoutWarningMessage = false;

    let selectedMethod = this.allMethods.find(x => x?.token == this.selectedToken);

    // Validation just in case they somehow select a payment method that we don't have a token associated with it or choose an expired/warning credit card
    if (!selectedMethod?.token) {
      this.flyoutSystemError = true;
    } else if (selectedMethod?.isExpired) {
      this.flyoutExpiredMessage = true;
    } else if (selectedMethod?.isWarning) {
      this.flyoutWarningMessage = true;
    } else {
      this.currentDefaultPaymentMethod = {
        cardType: !this.isPPI?selectedMethod?.cardType == 'EC' ? 'ECP' : selectedMethod.cardType:selectedMethod.creditCardType, // UI accounts for both 'EC' and 'ECP'
        ccExpiration: !this.isPPI?selectedMethod?.ccexpiration:selectedMethod?.ccExpiration,
        last4Digits: !this.isPPI?selectedMethod?.last4Digits:selectedMethod?.last4,
        ccHolderName: !this.isPPI?selectedMethod?.ccholderName:selectedMethod?.ccHolderName,
        isDefaultPaymentMethod: !this.isPPI?selectedMethod?.isDefaultPaymentMethod:selectedMethod?.isDefault,
        token: selectedMethod?.token,
        isExpired: selectedMethod?.isExpired,
        isWarning: selectedMethod?.isWarning
      };

      this.dialog.close(this.currentDefaultPaymentMethod); // Let the parent component know which updated payment method the user selected
    }
  }

  daysInMonth(m, y) {
    // month is 0-based: Jan = 0, Dec = 11
    // (m-1 ? Not February : February) checks if month is Feb
    // y & (y % 25 ? 3 : 15) is falsy for leap years, hence 31-2 days in Feb- otherwise, it's 31-3 days
    // m % 7 makes it so m is even for months with 31 days, odd for rest
    // subtracting lowest bit &1 results in 31-1 days for April/June/Sept/Nov, 31-0 for the rest
    // referenced stackexchange post for this function
    return 31 - (m - 1 ? m % 7 & 1 : y & (y % 25 ? 3 : 15) ? 3 : 2);
  }

  checkCCExpiration(ccExpiration, type) {
    const currentDate = new Date();let expirationYear:number;let expirationMonth:number;
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 because getMonth() returns 0-based index
    if(ccExpiration.length==6){ 
      expirationYear = parseInt(ccExpiration.slice(0, 4));
    expirationMonth = parseInt(ccExpiration.slice(4, 6));
    }
    else if(ccExpiration.length==4){ 
      expirationYear =parseInt(currentYear.toString().slice(0,2)+ ccExpiration.slice(2, 4));
    expirationMonth = parseInt(ccExpiration.slice(0, 2));
    }

    let isExpired;
    let isWarning;

    if (currentYear > expirationYear) {
      // Card is expired if current year is greater than expiration year
      isExpired = true;
      isWarning = false;
    } else if (currentYear === expirationYear && currentMonth > expirationMonth) {
      // Card is expired if current year is equal to expiration year and current month is greater than expiration month
      isExpired = true;
      isWarning = false;
    } else if (currentYear === expirationYear && currentMonth === expirationMonth) {
      const daysInMonth = this.daysInMonth(currentMonth, currentYear);
      const daysUntilExpiration = daysInMonth - currentDate.getDate();
      // Card technically does not expire until the end of the month, but if there are 5 or fewer days until expiration
      // Disallow them from using the payment method - so we set it as 'warning' and not 'expired' but user not allowed to use the payment method in either case.
      if (daysUntilExpiration <= 5) {
        isExpired = false;
        isWarning = true;
      } else {
        // There are still more than 5 days in the month before card expires, let them use the payment method.
        isExpired = false;
        isWarning = false;
      }
    } else {
      // Card is not expired
      isExpired = false;
      isWarning = false;
    }

    if (type == 'expired') {
      return isExpired;
    } else if (type == 'warning') {
      return isWarning;
    }
  }
  formatExpirationDate(expiration: string): string {
    if (!expiration || expiration.length !== 6)
      if(expiration.length==4)
        { const month = expiration.substring(0, 2); // Extract the year
          const year = expiration.substring(2, 4);
          
          return `${month}/${year}` }// Handle invalid input
          if(expiration.length==5)
            {return expiration}// Handle invalid input
    const year = expiration.substring(0, 4); // Extract the year
    const month = expiration.substring(4, 6); // Extract the month
  
    return `${month}/${year.substring(2, 4)}`; // Format as MM/YY
  }
}

